import { render, staticRenderFns } from "./SalaryExportRecordNew.vue?vue&type=template&id=7f132922"
import script from "./SalaryExportRecordNew.vue?vue&type=script&lang=js"
export * from "./SalaryExportRecordNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports